module.exports = __webpack_public_path__ + "static/media/0328_LES_ENSEIGNES_LE_PRIMEUR_SCRABBLE.7ea97d9e.webp";